import React from 'react';

const MarketPanelSectorNews = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Sector News</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="sector-news">
            <thead>
              <tr>
                <th>Icon</th>
                <th>Sector Name</th>
                <th>News</th>
                <th>Impact</th>
                <th>Date</th>
                <th>Source</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.icon || '-'}</td>
                    <td>{item.sector_name || '-'}</td>
                    <td>{item.news || '-'}</td>
                    <td>{item.impact || '-'}</td>
                    <td>{item.date || '-'}</td>
                    <td>{item.source || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelSectorNews; 